/**
 * The mark: a two-segment build badge.
 *
 * Every developer already knows what a green build badge means, and that
 * recognition is the entire brand — so the logo is not a drawing of a badge,
 * it is one. `build` sits on ink, `passing` on green, one hairline between
 * them, square corners.
 *
 * Real text rather than an SVG path, because it is a word and should behave
 * like one: it scales with the font, stays selectable, and is read correctly
 * aloud. The `aria-label` names the studio so a screen reader announces
 * "Build Passing" rather than the two halves as separate words.
 */
import styles from './Logo.module.css';

interface LogoProps {
  /** Height of the badge in pixels. The kit's minimum legible size is 16. */
  size?: number;
  /** On an ink ground the badge inverts: bone left half, lifted green right. */
  onInk?: boolean;
}

export function Logo({ size = 26, onInk = false }: LogoProps) {
  return (
    <span
      className={`${styles.badge} ${onInk ? styles.onInk : ''}`}
      style={{ '--badge-h': `${size}px` } as React.CSSProperties}
      role="img"
      aria-label="Build Passing"
    >
      <span className={styles.build} aria-hidden="true">
        build
      </span>
      <span className={styles.passing} aria-hidden="true">
        passing
      </span>
    </span>
  );
}
